import { useReducer } from "react"

type State<T> = T
type Action<T> = {
  type: keyof T
  value: T[keyof T]
}

const stateReducer = <T>(state: State<T>, action: Action<T>): State<T> => ({
  ...state,
  [action.type]: action.value
})

// Generic reducer for changing certainly fields of state
export const useGenericReducer = <T>(initialState: T) => {
  const [state, stateSetter] = useReducer<React.Reducer<State<T>, Action<T>>>(
    stateReducer,
    initialState
  )

  return { state, stateSetter }
}
